/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import {CloseIcon} from '../../icon';
import styles from './close-button.css';

type Props = {
    size?: number,
    className?: string,
    tooltip?: string,
    getRef?: (?HTMLButtonElement) => void,
    onClick: (e: SyntheticEvent<*>) => void,
    isLightVariant?: boolean, // For a lighter variant of the close button
};

export class CloseButton extends React.PureComponent<Props> {
    static defaultProps = {
        size: 14,
    };

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentWillUnmount() {
        ReactTooltip.hide();
    }

    render() {
        const containerStyles = this.props.isLightVariant
            ? styles['container--light']
            : styles.container;

        const className = this.props.className
            ? `${this.props.className} ${containerStyles}`
            : containerStyles;

        return (
            <button
                type='button'
                onClick={this.props.onClick}
                ref={this.props.getRef}
                data-tip={this.props.tooltip}
                className={className}
            >
                <CloseIcon size={this.props.size} />
            </button>
        );
    }
}
